import type { FunnelListItem, SortOrder } from '../types';
import type { FunnelPageRelationship, FunnelPageRelationshipKind } from './funnelRelationships';
import type { FunnelPageSlot } from './funnelPageSlots';

/**
 * Sort funnels by a given field, toggling ASC/DESC
 */
export function sortFunnels(funnels: FunnelListItem[], sortBy: string, sortOrder: SortOrder): FunnelListItem[] {
    return [...funnels].sort((a, b) => {
        const aVal = (a as unknown as Record<string, unknown>)[sortBy];
        const bVal = (b as unknown as Record<string, unknown>)[sortBy];

        if (typeof aVal === 'string' && typeof bVal === 'string') {
            return sortOrder === 'ASC' ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal);
        }

        if (typeof aVal === 'number' && typeof bVal === 'number') {
            return sortOrder === 'ASC' ? aVal - bVal : bVal - aVal;
        }

        return 0;
    });
}

type PageSlotOnly = Extract<FunnelPageSlot, { kind: 'page' }>;

/** Sort branches so upsells render before downsells, then everything else. */
export function sortFunnelPageBranches(
    branches: PageSlotOnly[],
    relationshipByPageId: Map<number, FunnelPageRelationship>
): PageSlotOnly[] {
    const rank = (k: FunnelPageRelationshipKind | undefined) => (k === 'upsell' ? 0 : k === 'downsell' ? 1 : 2);
    return [...branches].sort(
        (a, b) =>
            rank(relationshipByPageId.get(a.page.page_id)?.kind) - rank(relationshipByPageId.get(b.page.page_id)?.kind)
    );
}
